import { message } from 'antd'

import { fetchUtil as fetch, buildQuery } from 'src/utils/fetch'
import { saveAuditData } from 'src/api/audit'
import { omit, pick } from 'ramda'

export const getMetaverseCategory = async () => {
  try {
    const { data } = await fetch('/metaverse-rooms/rooms/categories')
    return data
  } catch (e) {
    message.error('Get Metaverse Category error!')
  }
}

export const getMetaverseRooms = async () => {
  try {
    const { data } = await fetch(`/metaverse-rooms/rooms/room-categories`)
    return data
  } catch (e) {
    message.error('Get Metaverse Rooms error!')
  }
}

export const getFeaturedMetaverseRooms = async () => {
  try {
    const { data } = await fetch(`/metaverse-rooms/rooms/featuredVenue`)
    return data
  } catch (e) {
    message.error('Get Featured Metaverse Rooms error!')
  }
}

export const setFeaturedMetaverseRooms = async (roomId) => {
  try {
    const { data } = await fetch(
      `/metaverse-rooms/rooms/featuredVenue/${roomId}`,
      {
        method: 'PATCH',
        headers: {
          role: 'ADMIN',
        },
      }
    )
    saveAuditData('EDIT', 'FEATUREDROOM', roomId)
    message.success('Success featured room edit!')
    return data
  } catch (e) {
    message.error('Fail to save featured metaverse rooms!')
  }
}

export const getMetaverseRoomsByCategory = async (category) => {
  try {
    const { data } = await fetch(`/metaverse-rooms/rooms/${category}`)
    return data
  } catch (e) {
    message.error('Get Metaverse Rooms by Category error!')
  }
}

export const saveEditMetaverse = async (
  id,
  name,
  title,
  titleFr,
  desc,
  accessLevels,
  img,
  thumbImage,
  splashImage
) => {
  try {
    const input = new FormData()
    input.append(
      'roomEditDto',
      new Blob(
        [
          JSON.stringify({
            id: id,
            title: title,
            titleFr: titleFr,
            description: desc,
            accessLevels: accessLevels,
          }),
        ],
        {
          type: 'application/json',
        }
      )
    )
    input.append('image', img)
    input.append('thumbImage', thumbImage)
    if (splashImage) {
      input.append('splashImage', splashImage)
    }

    const { data } = await fetch('/metaverse-rooms/rooms/edit', {
      method: 'POST',
      body: input,
      headers: {
        role: 'ADMIN',
      },
    })
    saveAuditData('EDIT', 'METAVERSE', name)
    message.success('Success Metaverse Room Edit!')
    return 'success'
  } catch (e) {
    message.error('Edit Metaverse Room error!')
    return 'failed'
  }
}
export const getAllRoomCategories = async () => {
  try {
    const res = await fetch(`/metaverse-rooms/rooms/room-categories`)
    if (Array.isArray(res?.data)) {
      const categories = {
        MUSIC: [],
        COUNTRIES: [],
        TWINS: [],
      }
      const twinsRooms = []

      res.data.forEach((room) => {
        if (room.type === 'MUSIC' || room.type === 'COUNTRIES') {
          categories[room.type].push(room)
        } else if (
          room.type === 'CLUB' ||
          room.type === 'CASINO' ||
          room.type === 'STADIUM'
        ) {
          room.rooms.forEach((rooms) => {
            twinsRooms.push({ ...rooms })
          })
        }
      })
      twinsRooms.sort(
        (a, b) => Number(a.twinSortIndex) - Number(b.twinSortIndex)
      )
      categories.TWINS.push({ type: 'TWINS', id: 'TWINS', rooms: twinsRooms })

      const result = [
        ...categories.MUSIC,
        ...categories.COUNTRIES,
        ...categories.TWINS,
      ]

      return result
    }
    throw 'Get all categories response wrong format'
  } catch (e) {
    message.error('getAll categories error ')
  }
}
export const updateMetaverseOrder = async (
  categoryId: string,
  updatedCategory: MetaverseRoomCategory
) => {
  try {
    await fetch(`/metaverse-rooms/rooms/update-order/${categoryId}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(updatedCategory),
    })
    saveAuditData('EDIT', 'METAVERSEORDER', categoryId)
  } catch (e) {
    message.error('updateMetaverses category error')
  }
}
export const getDiscovery = async () => {
  try {
    const { data } = await fetch('/metaverse-rooms/rooms/discovery')
    return data
  } catch (e) {
    message.error('Get Metaverse Category error!')
  }
}
export const fetchTriviaQuestionsAPI = async (
  type: string,
  page: number,
  size: number
) => {
  try {
    const { data } = await fetch(
      `/metaverse-rooms/games/trivia/${type}?page=${page}&size=${size}`
    )

    return data
  } catch (error) {
    message.error('Error fetching trivia questions')

    throw error
  }
}
export const validateQuestion = (question: Question): string | null => {
  if (!question.text.trim()) {
    return 'Question text is required!'
  }
  if (question.category == null || question.category.trim() === '') {
    return 'Question category is required!'
  }
  if (question.type == null || question.type.trim() === '') {
    return 'Question type is required!'
  }
  if (
    question.type !== 'TRUE_FALSE' &&
    (!question.answers || question.answers.length === 0)
  ) {
    return 'Please add at least one answer choice!'
  }

  if (
    question.type === 'SINGLE_CHOICE' &&
    (!question.correctAnswerIds || question.correctAnswerIds.length !== 1)
  ) {
    return 'Single choice question must have exactly one correct answer.'
  }

  if (
    question.type === 'MULTIPLE_CHOICE' &&
    (!question.correctAnswerIds || question.correctAnswerIds.length === 0)
  ) {
    return 'Multiple choice question must have at least one correct answer.'
  }

  if (
    question.type === 'TRUE_FALSE' &&
    (question.correctAnswer === null || question.correctAnswer === undefined)
  ) {
    return 'True/False question must have a correct answer.'
  }
  const hasEmptyAnswer = question.answers.some(
    (answer) => answer.text.trim() === ''
  )
  if (hasEmptyAnswer) {
    return 'Empty answers are not allowed.'
  }
  return null
}

export const getAllTriviaCategories = async () => {
  try {
    const { data } = await fetch(`/metaverse-rooms/games/trivia/quiz-category`)

    return data
  } catch (e) {
    message.error('get Trivia categories error ')
  }
}
export const getAllTriviaQuizType = async () => {
  try {
    const { data } = await fetch(`/metaverse-rooms/games/trivia/quiz-type`)

    return data
  } catch (e) {
    message.error('get Trivia quiz type error ')
  }
}

export const createTriviaQuestion = async (newQuestion: Question) => {
  try {
    const { data } = await fetch('/metaverse-rooms/games/trivia', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(newQuestion),
    })
    saveAuditData(
      'CREATE',
      'QUIZ',
      JSON.stringify({ questionText: newQuestion?.text })
    )
    return data
  } catch (e) {
    message.error('Search Games Error !')
  }
}
export const updateTriviaQuestion = async (
  id: string,
  newQuestion: Question
) => {
  try {
    const { data } = await fetch(`/metaverse-rooms/games/trivia/${id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(newQuestion),
    })
    saveAuditData(
      'UPDATE',
      'QUIZ',
      JSON.stringify({ questionText: newQuestion?.text })
    )
    return data
  } catch (e) {
    message.error('Search Games Error !')
  }
}
export const deleteTriviaQuestionAPI = async (question) => {
  try {
    const { data } = await fetch(
      `/metaverse-rooms/games/trivia/${question.id}`,
      {
        method: 'DELETE',
      }
    )
    saveAuditData(
      'DELETE',
      'QUIZ',
      JSON.stringify({ questionText: question?.text })
    )
    message.success('Delete question Successful')
    return data
  } catch (e) {
    message.error('Delete question Error !')
  }
}
export const searchTriviaQuestion = async (
  searchDto: SearchQuestion,
  page: number,
  size: number
) => {
  try {
    if (searchDto.category === '' || searchDto.category === undefined) {
      const { category, ...rest } = searchDto
      searchDto = rest
    }
    const { data } = await fetch(
      `/metaverse-rooms/games/trivia/search?page=${page}&size=${size}`,
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(searchDto),
      }
    )
    return data
  } catch (e) {
    message.error('Search Trivia Error !')
  }
}
export const getMainDiscovery = async (providerCountry?: string) => {
  try {
    const res = await fetch(`/metaverse-rooms/discovery/main/${providerCountry}`)

    if (res.data && Array.isArray(res.data.data)) {
      const transformedData = [
        {
          id: 'Main',
          type: 'Main',
          Main: res.data.data.map((item) => ({
            id: item.id,
            type: item.type,
            entityId: item.entityId,
            title: item.title,
            name: item.name,
            imageS3Path: item.imageS3Path,
          })),
        },
      ]

      return transformedData
    }

    throw 'Get main discovery response wrong format'
  } catch (e) {
    message.error('get main discovery error ')
  }
}
export const getDiscoveryEntityTypes = async () => {
  try {
    const { data } = await fetch(`/metaverse-rooms/discovery/type`)

    return data
  } catch (e) {
    message.error('get Games By All categories error ')
  }
}
export const addToMainDiscovery = async (entityId: string, type: string,providerCountry: string) => {
  try {
    await fetch(`/metaverse-rooms/discovery`, {
      method: 'POST',
      body: JSON.stringify({ entityId, type, providerCountry }),
      headers: {
        role: 'ADMIN',
      },
    })
  } catch (e) {
    message.error('update Games category error ')
  }
}
export const deleteFromMainDiscovery = async (provider: string,entityId: string) => {
  try {
    const { data } = await fetch(`/metaverse-rooms/discovery/${provider}/${entityId}`, {
      method: 'DELETE',
    })
    message.success('Delete  Successful')
    return data
  } catch (e) {
    message.error('Delete  Error !')
  }
}
export const getExscapeGuys = async (page, size, title = '') => {
  try {
    const { data } = await fetch('/metaverse-rooms/guys/search/admin', {
      method: 'POST',
      body: JSON.stringify({
        size: size,
        page: page,
        name: title,
      }),
      headers: {
        role: 'ADMIN',
      },
    })
    return data
  } catch (e) {
    message.error('Search Guys Error !')
  }
}
export const getMetaversesMainDiscovery = async (page, size, title = '') => {
  try {
    const { data } = await fetch('/metaverse-rooms/rooms/searchAdmin', {
      method: 'POST',
      body: JSON.stringify({
        size: size,
        page: page,
        name: title,
      }),
      headers: {
        role: 'ADMIN',
      },
    })
    return data
  } catch (e) {
    message.error('Search Games Error !')
  }
}

export const getMetaverseCategoryById = async (id) => {
  try {
    const { data } = await fetch(`/metaverse-rooms/rooms/id/${id}`)
    return data
  } catch (e) {
    message.error('Get Metaverse By Id error!')
  }
}

export const getEventsByProviderCountry = async (providerCountry: string) => {
  try {
    return await fetch(
      `/metaverse-rooms/game-events/provider-country/${encodeURIComponent(providerCountry)}`,
      { method: 'GET' }
    )
  } catch (e) {
    message.error('Get Events By Provider Country error!')
    throw e
  }
}
export const searchAllGames = async (params: Record<string, any>) => {
  const query = buildQuery(pick(['page', 'pageSize'], params))
  const body = omit(['page', 'pageSize','size'], params)
  
  try {
    

    const { data } = await fetch(`/metaverse-rooms/games/search-all-game-type?${query}`, {
      method: 'POST',
      body: JSON.stringify(body),
    })
    return data
  } catch (e) {
    message.error('search All Games Report error !')
  }
}